import React from 'react';
import PropTypes from 'prop-types';
import { Default, Mobile } from 'components/Responsive';
import Button from 'components/Button';

const DefaultCartButton = (props) => {
  const {
    actionType,
    subType,
    title,
    rightIcon,
    leftIcon,
    disabled,
    isCallToPurchase,
    callToPurchaseHandler,
    callToPurchasePage,
    callToPurchasePhoneNumber,
    addToCartHandler,
  } = props;

  const CreateButton = (callToPurchaseLocation) => (
    <Button
      actionType={actionType}
      subType={subType}
      title={title}
      rightIcon={rightIcon}
      leftIcon={leftIcon}
      disabled={disabled}
      onClick={
          isCallToPurchase ? (e) => callToPurchaseHandler(callToPurchaseLocation, e) : () => addToCartHandler()
        }
    />
  );

  return ([
    <Default key='Default'>
      {CreateButton(callToPurchasePage)}
    </Default>,
    <Mobile key='Mobile'>
      {CreateButton(`tel:${callToPurchasePhoneNumber}`)}
    </Mobile>,
  ]);
};

DefaultCartButton.propTypes = {
  actionType: PropTypes.string,
  subType: PropTypes.string,
  title: PropTypes.string,
  rightIcon: PropTypes.string,
  leftIcon: PropTypes.string,
  disabled: PropTypes.bool,
  isCallToPurchase: PropTypes.bool,
  callToPurchasePage: PropTypes.string,
  callToPurchasePhoneNumber: PropTypes.string,
  callToPurchaseHandler: PropTypes.func,
  addToCartHandler: PropTypes.func,
};

export default DefaultCartButton;
